import React from 'react';
import {arrayOf, bool, func, object, shape, string} from 'prop-types';
import {Button, Grid, Header, Icon, Radio} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import {byField, clone} from 'utils/DBUtils';
import partial from 'lodash/partial';
import MasterColumn from './MasterColumn';

export default class StepManagementAccordion extends React.Component {
  static propTypes = {
    break: object,
    masterResourceId: shape({
      type: string,
      id: string
    }),
    savingStepOrder: bool,
    openAddStepsModal: func.isRequired
  };

  state = {
    steps: [],
    sortable: false
  };

  constructor(props) {
    super(props);

    // called in other contexts
    this.toggleSortability = this.toggleSortability.bind(this);
    this.findStep = this.findStep.bind(this);
    this.moveStep = this.moveStep.bind(this);
  }

  componentDidMount() {
    // TODO: This needs to be updated to use current platform
    this.loadSteps(this.props.break.MASTER.steps);
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.savingStepOrder) {
      this.loadSteps(nextProps.break.MASTER.steps);
    }
  }

  loadSteps = (steps = []) => {
    this.setState({
        // Need to slice before sort to prevent modification of props and, as a result, the state
      steps: steps.slice().sort(byField('displayOrder'))
    });
  };

  toggleSortability(event, data) {
    this.setState({sortable: data.checked});
  }

  findStep(id) {
    const { steps } = this.state;
    const step = steps.find(s => s.id === id);
    return {
      step,
      index: steps.indexOf(step)
    };
  }

  moveStep(id, atIndex) {
    const { step, index } = this.findStep(id);
    const nextSteps = clone(this.state.steps);

    nextSteps.splice(index, 1);
    nextSteps.splice(atIndex, 0, step);

    const stepNumbersAndResourceIds = nextSteps.map((step, index) => step.displayOrder);

    // Set new display orders
    // let i = 1;
    // for (let step of nextSteps) {
    //   step.displayOrder = i;
    //   i++;
    // }
    // console.log('next steps', nextSteps);
    // this.setState({steps: nextSteps});

    this.props.saveStepNumbers(stepNumbersAndResourceIds);
  }

  deleteStep = (step) => {
      let index = this.props.break.MASTER.steps.findIndex((item) => item.id === step.id);
      this.props.deleteStep(step, index);
  };

  togglePublishStep = (step) => {
      let index = this.props.break.MASTER.steps.findIndex((item) => item.id === step.id);
      this.props.togglePublishStep(step, index);
  };

  renameStep = (step) => {
    const index = this.props.break.MASTER.steps.findIndex((item) => item.id === step.id);
    this.props.openRenameStepModal(step, index);
  };

  onStepClick = (step, index) => {
    this.props.onStepClick(step, index);
  };

  render() {
    return (
      <section>
        <Header as="h5" className="header-text-brown small-h5">
          <FormattedMessage id="editbreak.step_management.header" />
        </Header>
        <p className="step-management-sub-header">
          <FormattedMessage id="editbreak.step_management.subheader" />
        </p>
        <Grid className="step-management-grid">
          <Grid.Row>
            <Grid.Column width={5}>
              <Button
                onClick={partial(this.props.openAddStepsModal, 'MASTER')}
                className="db-button-add-step">
                <Icon name="plus" />
                <FormattedMessage id="editbreak.view_all.button.add" />
              </Button>
            </Grid.Column>
            <Grid.Column width={5}>
              {this.state.steps.length > 1 && (
                <React.Fragment>
                  <Radio className="db-blue-radio" toggle onClick={this.toggleSortability} />
                  <FormattedMessage id="editbreak.step_management.reorder" />
                </React.Fragment>
              )}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            {this.state.steps && (
              <MasterColumn
                  width={12}
                  breakObj={this.props.break}
                  steps={this.state.steps}
                  sortable={this.state.sortable}
                  onStepClick={this.onStepClick}
                  deleteStep={this.deleteStep}
                  togglePublishStep={this.togglePublishStep}
                  renameStep={this.renameStep}
                  findStep={this.findStep}
                  moveStep={this.moveStep} />
            )}
          </Grid.Row>
        </Grid>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./public/components/steps/StepManagementAccordion.jsx